"use client";
import {
  button_default
} from "../../chunk-CBJJ6H3K.js";
export {
  button_default as default
};
